module.exports = __webpack_public_path__ + "img/04-changeData.fff08098.png";